import { render, staticRenderFns } from "./LayersLoader.vue?vue&type=template&id=56e51433&scoped=true"
import script from "./LayersLoader.vue?vue&type=script&lang=js"
export * from "./LayersLoader.vue?vue&type=script&lang=js"
import style0 from "./LayersLoader.vue?vue&type=style&index=0&id=56e51433&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e51433",
  null
  
)

export default component.exports